import { createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-768b8be4")

_pushScopeId("data-v-768b8be4")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "blind" }, "Top으로", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("a", {
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.moveToTop && _ctx.moveToTop(...args)), ["prevent"])),
    class: "sp btn_top"
  }, [
    _hoisted_1
  ], 512)), [
    [_vShow, !_ctx.isTop]
  ])
})